/**
 * Official Microsoft Teams Icon (2025 Design - Fluid Forms, Vibrant Colors)
 * Source: Public Domain from Wikimedia Commons
 * https://commons.wikimedia.org/wiki/File:Microsoft_Office_Teams_(2025–present).svg
 */

export function TeamsIcon({ size = 64 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="4 4 36 38"
      width={size}
      height={size}
      style={{ display: 'block' }}
    >
      <defs>
        <radialGradient id="teams-a" cx="0" cy="0" r="1" gradientTransform="matrix(13.4784 0 0 33.2694 39.7967 22.1739)" gradientUnits="userSpaceOnUse">
          <stop stopColor="#a98aff"/>
          <stop offset=".14" stopColor="#8c75ff"/>
          <stop offset=".565" stopColor="#5f50e2"/>
          <stop offset=".9" stopColor="#3c2cb8"/>
        </radialGradient>
        <radialGradient id="teams-b" cx="0" cy="0" r="1" gradientTransform="rotate(68.1539 -7.71566095 14.71355834)scale(32.752 33.1231)" gradientUnits="userSpaceOnUse">
          <stop stopColor="#85c2ff"/>
          <stop offset=".69" stopColor="#7588ff"/>
          <stop offset="1" stopColor="#6459fe"/>
        </radialGradient>
        <linearGradient id="teams-c" x1="20.5936" x2="20.5936" y1="18" y2="42" gradientUnits="userSpaceOnUse">
          <stop offset=".801159" stopColor="#6864f6" stopOpacity="0"/>
          <stop offset="1" stopColor="#5149de"/>
        </linearGradient>
        <radialGradient id="teams-d" cx="0" cy="0" r="1" gradientTransform="rotate(113.326 8.09285255 17.64474501)scale(19.2186 15.4273)" gradientUnits="userSpaceOnUse">
          <stop stopColor="#bd96ff"/>
          <stop offset=".686685" stopColor="#bd96ff" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="teams-e" cx="0" cy="0" r="1" gradientTransform="matrix(0 -10 12.6216 0 32.9999 11.5714)" gradientUnits="userSpaceOnUse">
          <stop offset=".268201" stopColor="#6868f7"/>
          <stop offset="1" stopColor="#3923b1"/>
        </radialGradient>
        <radialGradient id="teams-f" cx="0" cy="0" r="1" gradientTransform="rotate(40.0516 -.03068196 44.8729095)scale(7.14629 10.3363)" gradientUnits="userSpaceOnUse">
          <stop offset=".270711" stopColor="#a1d3ff"/>
          <stop offset=".813393" stopColor="#a1d3ff" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="teams-g" cx="0" cy="0" r="1" gradientTransform="rotate(-41.6581 32.11799918 -43.41948423)scale(8.51275 20.8824)" gradientUnits="userSpaceOnUse">
          <stop stopColor="#e3acfd"/>
          <stop offset=".816041" stopColor="#9fa2ff" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="teams-h" cx="0" cy="0" r="1" gradientTransform="matrix(0 -12 15.146 0 17.9999 8.28571)" gradientUnits="userSpaceOnUse">
          <stop offset=".268201" stopColor="#8282ff"/>
          <stop offset="1" stopColor="#3923b1"/>
        </radialGradient>
        <radialGradient id="teams-i" cx="0" cy="0" r="1" gradientTransform="rotate(40.0516 -3.15465147 21.41641466)scale(8.57554 12.4035)" gradientUnits="userSpaceOnUse">
          <stop offset=".270711" stopColor="#a1d3ff"/>
          <stop offset=".813393" stopColor="#a1d3ff" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="teams-j" cx="0" cy="0" r="1" gradientTransform="rotate(-41.6581 20.38180375 -26.51566158)scale(10.2153 25.0589)" gradientUnits="userSpaceOnUse">
          <stop stopColor="#e3acfd"/>
          <stop offset=".816041" stopColor="#9fa2ff" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="teams-k" cx="0" cy="0" r="1" gradientTransform="rotate(45 -25.76345597 16.32842712)scale(22.6274)" gradientUnits="userSpaceOnUse">
          <stop offset=".046875" stopColor="#688eff"/>
          <stop offset=".946875" stopColor="#230f94"/>
        </radialGradient>
        <radialGradient id="teams-l" cx="0" cy="0" r="1" gradientTransform="matrix(0 11.2 -13.0702 0 12 32.6)" gradientUnits="userSpaceOnUse">
          <stop offset=".570647" stopColor="#6965f6" stopOpacity="0"/>
          <stop offset="1" stopColor="#8f8fff"/>
        </radialGradient>
      </defs>
      <path fill="url(#teams-a)" d="M21.9999 20h12c3.3137 0 6 2.6863 6 6v10c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6V26c0-3.3137-2.6863-6-6-6"/>
      <path fill="url(#teams-b)" d="M7.99988 24c0-3.3137 2.68632-6 6.00002-6h8c3.3137 0 6 2.6863 6 6v12c0 3.3137 2.6863 6 6 6l-16.0001-.0001c-5.5228 0-9.99992-4.4771-9.99992-10z"/>
      <path fill="url(#teams-c)" fillOpacity=".7" d="M7.99988 24c0-3.3137 2.68632-6 6.00002-6h8c3.3137 0 6 2.6863 6 6v12c0 3.3137 2.6863 6 6 6l-16.0001-.0001c-5.5228 0-9.99992-4.4771-9.99992-10z"/>
      <path fill="url(#teams-d)" fillOpacity=".7" d="M7.99988 24c0-3.3137 2.68632-6 6.00002-6h8c3.3137 0 6 2.6863 6 6v12c0 3.3137 2.6863 6 6 6l-16.0001-.0001c-5.5228 0-9.99992-4.4771-9.99992-10z"/>
      <path fill="url(#teams-e)" d="M32.9999 18c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"/>
      <path fill="url(#teams-f)" fillOpacity=".46" d="M32.9999 18c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"/>
      <path fill="url(#teams-g)" fillOpacity=".4" d="M32.9999 18c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"/>
      <path fill="url(#teams-h)" d="M17.9999 16c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6s-6 2.68629-6 6c0 3.3137 2.6863 6 6 6"/>
      <path fill="url(#teams-i)" fillOpacity=".6" d="M17.9999 16c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6s-6 2.68629-6 6c0 3.3137 2.6863 6 6 6"/>
      <path fill="url(#teams-j)" fillOpacity=".5" d="M17.9999 16c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6s-6 2.68629-6 6c0 3.3137 2.6863 6 6 6"/>
      <rect width="16" height="16" x="4" y="23" fill="url(#teams-k)" rx="3.25"/>
      <rect width="16" height="16" x="4" y="23" fill="url(#teams-l)" fillOpacity=".7" rx="3.25"/>
      <path fill="#fff" d="M15.4792 28.1054h-2.4471v7.466h-2.0648v-7.466H8.52014v-1.6768h6.95906z"/>
    </svg>
  );
}
